// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"bd18a73e","385":"5a6f8dd0","419":"2edc7929","461":"7e3fb70f","462":"498950a2","470":"38a139b7","501":"39dbd218","569":"50b4a320","835":"5f27bbf8","938":"3ad9d279"}[chunkId] + ".chunk.js";
};